export default __webpack_public_path__ + "static/media/financiero2025Pdf.61b6ef95.pdf";